module.exports = __webpack_public_path__ + "img/meter-fire.28903bb8.svg";